module.exports = "pegasus_template/assets/themelp1/creative/105.png";